var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "sync-fullscreen"
  }, [_c('div', {
    staticClass: "sync-card"
  }, [_c('img', {
    staticClass: "sync-logo",
    attrs: {
      "src": "media/brand/logo.png",
      "alt": "PDV Desktop"
    }
  }), _c('h2', [_vm._v("Sincronizando dados")]), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(" Aguarde enquanto baixamos produtos e clientes para o PDV offline. ")]), _c('div', {
    staticClass: "progress mt-4 mb-2",
    staticStyle: {
      "height": "12px"
    }
  }, [_c('div', {
    staticClass: "progress-bar bg-primary",
    style: {
      width: _vm.progresso + '%'
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.progresso,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]), _c('p', {
    staticClass: "status-text"
  }, [_vm._v(_vm._s(_vm.statusSync))]), _vm.erro ? _c('div', {
    staticClass: "alert alert-danger mt-3 text-left"
  }, [_vm._v(" " + _vm._s(_vm.erro) + " "), _c('br'), _c('button', {
    staticClass: "btn btn-sm btn-outline-danger mt-2",
    on: {
      "click": _vm.iniciarSync
    }
  }, [_vm._v(" Tentar novamente ")])]) : _vm._e(), _vm.concluido ? _c('div', {
    staticClass: "alert alert-success mt-3"
  }, [_vm._v(" ✓ Sincronização concluída! Abrindo o PDV... ")]) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };